import moment from "moment";
import formatters from "@/helpers/formatters";
import validators from "@/helpers/validators";

export default {
    toTodaysTime(timeMoment, todayMoment) {
        const hour = timeMoment.get("hour");
        const minute = timeMoment.get("minute");

        const result = todayMoment
            .clone()
            .add(hour, "hour")
            .add(minute, "minute");

        return result;
    },
    bookingEndTime(advanceBookingDays, bookingReleaseTimeString, time) {
        const momentNow = time.nowMoment;
        const todayMoment = time.todayMoment;

        const todaysBookingEndTime = todayMoment.clone().add(1, "days");

        const bookingReleaseTimeRaw = moment(
            bookingReleaseTimeString
        );

        const bookingReleaseTime = this.toTodaysTime(bookingReleaseTimeRaw, todayMoment)

        let endTime = null;

        if (advanceBookingDays > 0) {
            const advanceBookingEndTime = todaysBookingEndTime.clone().add(
                advanceBookingDays,
                "days"
            );

            if (momentNow >= bookingReleaseTime) {
                endTime = advanceBookingEndTime;
            } else {
                endTime = advanceBookingEndTime.clone().add(-1, "days");
            }
        } else {
            endTime = todaysBookingEndTime;
        }

        return endTime;
    },
    timeList(openingTimeMoment, lastBookingTimeMoment, bookingTimeslotInMinutes, isSameDate, nowMoment, todayMoment) {
        const todaysOpeningTimeMoment = this.toTodaysTime(openingTimeMoment, todayMoment)

        // console.log("timeList", nowMoment.format())
        // console.log("openingTimeMoment", openingTimeMoment.format())
        // console.log("lastBookingTimeMoment", lastBookingTimeMoment.format())
        // console.log("todaysOpeningTimeMoment", todaysOpeningTimeMoment.format())

        if (todaysOpeningTimeMoment && lastBookingTimeMoment && bookingTimeslotInMinutes) {
            let timeList = [];

            for (
                let i = todaysOpeningTimeMoment;
                i <= lastBookingTimeMoment;
                i = i
                    .clone()
                    .add(bookingTimeslotInMinutes, "minutes")
            ) {
                timeList.push({
                    code: i.format("HH:mm"),
                    name: i.format("h:mm a"),
                });
            }

            if (isSameDate) {
                timeList = timeList.filter(
                    (x) => this.toTodaysTime(moment(x.code, "HH:mm"), todayMoment) > nowMoment
                );
            }

            // console.log("timeList", JSON.stringify(timeList))
            return timeList;
        }

        return null;
    },
    durationList(minBookingMinutes, maxBookingMinutes, bookingTimeslotInMinutes,
        closingTimeMoment, selectedTimeMoment, todayMoment) {
        const todaysClosingTime = this.toTodaysTime(closingTimeMoment, todayMoment)
        const todaysSelectedTime = this.toTodaysTime(selectedTimeMoment, todayMoment)

        if (minBookingMinutes && maxBookingMinutes && bookingTimeslotInMinutes) {
            let durationList = [];
            for (
                let i = minBookingMinutes;
                i <= maxBookingMinutes;
                i += bookingTimeslotInMinutes
            ) {
                durationList.push({
                    code: i,
                    name: formatters.convertMinutesToHoursMinutes(i),
                });
            }

            if (todaysClosingTime && todaysSelectedTime) {
                durationList = durationList.filter(
                    (x) =>
                        todaysSelectedTime.clone().add(x.code, "minutes") <=
                        todaysClosingTime
                );
            }

            return durationList;
        }

        return null;
    },
    getVisitBookingTimeslotsAndDurations(openingHours, visitBookingTimeIntervalInMinutes, visitBookingDurationInMinutes,
        dwellMinutesOfTheDay, bookingDateMoment) {
        // - OpeningHours - E.g. {"defaultOpeningHours":[{startTime: "2021-12-07T09:00:00+08:00", endTime: "2021-12-07T15:00:00+08:00"},{"startTime":"2021-12-07T16:00:00+08:00","endTime":"2021-12-07T20:00:00+08:00"}]}
        const timeslotsAndDurations = [];
        const openingHoursOfTheDay = openingHours.defaultOpeningHours;

        const durationOfTheDayInMinutes = dwellMinutesOfTheDay
            ? Math.min(
                dwellMinutesOfTheDay,
                visitBookingDurationInMinutes
            )
            : visitBookingDurationInMinutes;

        openingHoursOfTheDay.forEach(x => {
            const startTimeOfTheDayMoment = this.toTodaysTime(moment(x.startTime), bookingDateMoment);
            const endTimeOftheDayMoment = this.toTodaysTime(moment(x.endTime), bookingDateMoment)

            for (var i = startTimeOfTheDayMoment; i < endTimeOftheDayMoment; i = i.add(visitBookingTimeIntervalInMinutes, "minutes")) {
                let durationInMinutes = durationOfTheDayInMinutes;
                if (i.clone().add(durationOfTheDayInMinutes, "minutes") > endTimeOftheDayMoment) {
                    durationInMinutes = endTimeOftheDayMoment.clone().diff(i.clone(), "minutes");
                }

                timeslotsAndDurations.push({ timeslot: i.clone(), durationInMinutes: durationInMinutes });
            }
        });

        return timeslotsAndDurations;
    },
    visitBookingCalendar(timeslotsAndDurations, advanceBookingDays, bookingReleaseTime, openingDaysOfWeek, holidays, branchCode, time) {
        const nowMoment = time.nowMoment;
        const todayMoment = time.todayMoment;
        let bookingStartDate = todayMoment.clone();

        const bookingEndTime = this.bookingEndTime(advanceBookingDays, bookingReleaseTime, time);
        const bookingEndDate = bookingEndTime.clone().startOf("day").add(-1, "days");

        //Try to bypass library closing days. E.g. Library opens only on the weekends, if today is Friday, and Saturday is bookable now, 
        //the calendar start date will be set to Saturday instead of Friday
        if (bookingEndDate > bookingStartDate) {
            for (var i = bookingStartDate; i <= bookingEndDate; i = i.clone().add(1, "days")) {                
                const isBranchOpenToday = validators.isBranchOpenToday(
                    i,
                    openingDaysOfWeek,
                    holidays,
                    branchCode
                );

                if (isBranchOpenToday) {
                    bookingStartDate = i;
                    break;
                }
            }
        }

        //Try to set the start date of the calendar to tomorrow if no bookable timeslots are available for today
        const lastTimeslotOfToday = this.toTodaysTime(timeslotsAndDurations.slice(-1)[0].timeslot, todayMoment)

        if (bookingStartDate < bookingEndDate && bookingStartDate.isSame(todayMoment) && nowMoment >= lastTimeslotOfToday) {
            bookingStartDate.add(1, "days");
        }

        const calendar = { min: bookingStartDate.format("YYYY-MM-DD"), max: bookingEndDate.format("YYYY-MM-DD") };
        return calendar;
    },
    getVistiBookingTimeslots(openingHours, visitBookingTimeIntervalInMinutes) {
        // - OpeningHours - E.g. {"defaultOpeningHours":[{startTime: "2021-12-07T09:00:00+08:00", endTime: "2021-12-07T15:00:00+08:00"},{"startTime":"2021-12-07T16:00:00+08:00","endTime":"2021-12-07T20:00:00+08:00"}]}
        const timeslots = [];
        const openingHoursOfTheDay = openingHours.defaultOpeningHours;

        openingHoursOfTheDay.forEach(x => {
            const startTimeOfTheDayMoment = moment(x.startTime);
            const endTimeOftheDayMoment = moment(x.endTime);

            for (var i = startTimeOfTheDayMoment; i < endTimeOftheDayMoment; i = i.add(visitBookingTimeIntervalInMinutes, "minutes")) {
                timeslots.push(i.clone());
            }
        });

        return timeslots;
    },
    visitBookingTimeList(openingHours, visitBookingTimeIntervalInMinutes, isSameDate, nowMoment, todayMoment) {
        //Visit booking time list depends on the selected branch and the selected calendar date.
        //E.g. If the selected calendar date is today, passed timeslots shouldn't be shown

        if (openingHours && visitBookingTimeIntervalInMinutes) {
            let timeList = [];
            const timeslots = this.getVistiBookingTimeslots(openingHours, visitBookingTimeIntervalInMinutes);

            timeslots.forEach(x => {
                if (!isSameDate || (isSameDate && this.toTodaysTime(x, todayMoment) > nowMoment)) {
                    timeList.push({
                        code: x.format("HH:mm"),
                        name: x.format("h:mm a"),
                    });
                }
            });

            // console.log("timeList", JSON.stringify(timeList))
            return timeList;
        }

        return null;
    },
    visitBookingDurationList(timeslotsAndDurations, selectedTimeMoment) {
        //Visit booking duration list depends on branch, selected date (Dwell time can be different for different dates) and selected time
        const selectedTimeslotAndDuration = timeslotsAndDurations
            .find(x => x.timeslot.format("HH:mm") === selectedTimeMoment.format("HH:mm"));

        if (selectedTimeslotAndDuration) {
            const durationList = [{
                code: selectedTimeslotAndDuration.durationInMinutes,
                name: formatters.convertMinutesToHoursMinutes(selectedTimeslotAndDuration.durationInMinutes)
            }];

            return durationList;
        }

        return null;
    },
    paxList(visitBookingMaxPax) {
        let paxList = [];
        for (let i = 1; i <= visitBookingMaxPax; i++) {
            paxList.push({
                code: i,
                name: i.toString(),
            });
        }

        return paxList;
    }
}